import { Box, styled, Typography } from '@mui/material';
import { Drawer } from 'components/shared';

export const StyledProcedureDescription = styled(Typography)({
  whiteSpace: 'pre-wrap'
});

export const StyledProcedureWarning = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const StyledProcedureWarningText = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.dark,
  fontWeight: theme.typography.fontWeightBold
}));

export const StyledPage = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hidden'
})<{ hidden?: boolean }>(({ hidden }) => ({
  // The history grid must stay mounted rather than being unmounted on page switch: it portals
  // its own toolbar into the shared DataGridToolBar-root above the tab content, and that portal
  // collapses to 0 height when nothing is mounted into it - unmounting/remounting it on every
  // switch is what made the MenuButton appear to jump vertically.
  display: hidden ? 'none' : 'block'
}));

export const StyledPageContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const StyledPreviewSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  paddingTop: theme.spacing(2)
}));

export const StyledStartRow = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2)
}));

export const StyledDoneText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const StyledProcedureRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0),
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const StyledWideDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '65%',
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius
  }
}));

export const StyledDrawerContentBox = styled(Box)(({ theme }) => ({
  // The shared Drawer's content area has no padding of its own (StyledDrawerContent is bare) -
  // without this, PeriodSelector and ActionToExecute sit flush against the drawer edges.
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5)
}));
